export class BillRecap {

    constructor(
        public productType : string,
        public numberOfItems : number,
        public unitPrice : number,
        public totalPrice : number,
    ) {  }
  
  }